import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { GetInviteeParams, InviteeOut } from "@/types/workspace-invite";
import { handleResponse } from "@/utils/errorResponseHandlers";

export const useGetInviteeData = (params: GetInviteeParams) => {
  const url = new URL(ENDPOINTS.get_invitee);
  url.searchParams.append("invite_code", params.invite_code);

  return useQuery(
    [ENDPOINTS.get_invitee, params],
    (): Promise<InviteeOut[]> =>
      fetch(url, {
        headers: {
          "Content-Type": "application/json",
        },
      }).then(handleResponse),
    {
      retry: false,
      enabled: !!params.invite_code,
    },
  );
};
